import { Container, Row, Col, Alert, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Password.css';

import tutorImg from '../shared/image/Dial_Tutor.png';

export default function AdminPassword() {
  return (
    <Container fluid className="mainss-containerss">
      <Row className="loginss-cardss">
        <Col md={6} className="image-section">
          <img src={tutorImg} alt="Dialtutor" />
        </Col>
        <Col md={6} className="formss-sectionss">
          <h4 className="mb-4">Forgot Password</h4>
          <Alert variant="info" className="py-2 mb-3">
            <p className="mb-2">Admin credentials can only be reset directly on the server. Run on the host:</p>
            <pre className="mb-2 small bg-light p-2 rounded">php db/install.php</pre>
            <p className="small mb-0 text-muted">This re-seeds the default admin (admin@dailytutor.in / admin123) only if no admin exists yet — otherwise reset via direct DB update.</p>
          </Alert>
          <Button as={Link} to="/admin/login" className="subtss">
            Back to Login
          </Button>
        </Col>
      </Row>
    </Container>
  );
}
